const RolesAccessControl = {
  rolesAccessHandler: (availableRoles, accessRoles) => {
    return availableRoles.some((role) => accessRoles.some((r) => r === role));
  },
};

export default RolesAccessControl;
